module.exports = __webpack_public_path__ + "media/chat-notif.8646c43b.wav";